module.exports = __webpack_public_path__ + "static/img/honor-logo.1cef5b21.png";